import { ReactElement, ReactNode, useState } from "react"
import { v4 as uuid4 } from "uuid"

import CreateHpDeviceProvider from "./baseProviders/createHpDeviceProvider"
import { useGetUserData } from "../../../../../hooks/useGetUserData"
import { getEmptyHpDeviceFormData } from "../../formSpecs/hpSpec"
import { HpDeviceFormData } from "../../types/providerTypes"

interface IPublishHpDeviceProviderProps {
    children: ReactNode
}

/** Provide for the publish HP provider form */
const PublishHpDeviceProvider = ({
    children,
}: IPublishHpDeviceProviderProps): ReactElement => {
    const [formData, setFormData] = useState<HpDeviceFormData>(
        getEmptyHpDeviceFormData()
    )

    const { isEnaSysAdmin } = useGetUserData()

    const [attachmentUUID] = useState<string>(uuid4())

    return (
        <CreateHpDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={false}
            canEditManufacturer={isEnaSysAdmin}
            attachmentUUID={attachmentUUID}
        >
            {children}
        </CreateHpDeviceProvider>
    )
}

export default PublishHpDeviceProvider
